// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__22lbr","location":"Header_location__3zVTE"};